import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type BreadcrumbElements = {
  breadcrumb: SxProps
  base: SxProps
  section: SxProps
  subsection: SxProps
}

export const breadcrumbStyles: BreadcrumbElements = {
  breadcrumb: {
    position: 'sticky',
    top: 0,
    fontSize: 22,
    padding: '30px 0 8px',
    backgroundColor: theme.colors.white01,
    zIndex: 1,
    borderBottom: `2px solid ${theme.colors.gray300}`
  },

  base: {
    color: theme.palette.text.secondary
  },

  section: {
    fontFamily: theme.corporate.primaryFont,
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '28px',
    color: theme.colors.highlight200,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    height: 28
  },

  subsection: {
    fontFamily: theme.corporate.secondaryFont,
    fontSize: '16px'
  }
}
